import { ReactNode } from 'react';
import { DynamicFormPage } from './_dynamic_form_page.component';
import { useDynamicFormContext } from './dynamic_form.context';
import { useFormWorkerState } from './form_manager/use_form_worker';

interface DynamicFormContentProps {
	children: ReactNode;
}

export function DynamicFormContent({ children }: DynamicFormContentProps): JSX.Element | null {
	const context = useDynamicFormContext();
	const { meta, pagePosition } = useFormWorkerState(context.formWorker);

	if (meta == null) {
		return null;
	}

	return (
		<DynamicFormPage page={meta.pages[pagePosition]} formWorker={context.formWorker}>
			{children}
		</DynamicFormPage>
	);
}
